import { Thunk } from 'ha/myredux/types';
import { Actions } from '../constants';

const detectLanguage =
  (description: string): Thunk =>
  (dispatch, _, { translation }) => {
    dispatch({
      type: Actions.DETECT_DESCRIPTION_LANGUAGE_START,
      payload: description,
      error: false,
    });

    return translation
      .detectLanguage(description)
      .then(lang =>
        dispatch({
          type: Actions.DETECT_DESCRIPTION_LANGUAGE_DONE,
          payload: lang,
          error: false,
        }),
      )
      .catch(error =>
        dispatch({
          type: Actions.DETECT_DESCRIPTION_LANGUAGE_FAIL,
          error: true,
          payload: error,
        }),
      );
  };

export { detectLanguage };
